 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"210db0215931a3e9abee96710e518434acd7c4c0","3":"2fe454eb43ef5d9bb0bb87b43c87706ffeecd892","4":"40b72ecc2a5accc75505486bc26963c7c3b80314","5":"6be459cf3a0383e4f851e82f8f9153af809a37a0","6":"841b02cfb9bcee3ef27fe7f103f51795a4c4c5ae","7":"834b794a2fa97d63fcd1d48709d635bc2bbabd88","8":"b4f28b8dde38944e0d9167a2fa550033034c9e0b","12":"component---src-pages-approach-js","13":"component---src-pages-become-a-carer-js","14":"component---src-pages-blog-js","15":"component---src-pages-care-consultation-js","16":"component---src-pages-companionship-care-js","17":"component---src-pages-condition-cancer-js","18":"component---src-pages-condition-dementia-js","19":"component---src-pages-condition-multiple-sclerosis-js","20":"component---src-pages-condition-parkinsons-js","21":"component---src-pages-condition-stroke-js","22":"component---src-pages-cookies-js","23":"component---src-pages-couples-care-js","24":"component---src-pages-cta-js","25":"component---src-pages-index-js","26":"component---src-pages-live-in-care-south-east-london-js","27":"component---src-pages-liveincare-js","28":"component---src-pages-liveincare-looking-for-care-js","29":"component---src-pages-our-carers-js","30":"component---src-pages-our-team-js","31":"component---src-pages-partner-with-us-js","32":"component---src-pages-pricing-js","33":"component---src-pages-privacy-js","34":"component---src-pages-privacy-version-1-0-js","35":"component---src-pages-request-a-brochure-js","36":"component---src-pages-social-media-studio-js","37":"component---src-pages-terms-and-conditions-js","38":"component---src-templates-blog-post-js","39":"component---src-templates-location-js"}[chunkId]||chunkId) + "-" + {"0":"c049f1ec513eda996e3c","1":"e9d24b1846c7d6eb9685","2":"2bb88e0f85708111b942","3":"7f42a0b1522d18d8319e","4":"33077a76aff6b912e446","5":"1a3bf46c49e4d16e0c8f","6":"6f3fc92cb6d32323e928","7":"095d88524e7899e04d1d","8":"58cfc4a71cc0ce59ee47","10":"ee93b92a762ab5455a2f","12":"fa83dd11f60d953e5293","13":"3bb5708e4f86f5ba545d","14":"434e7edc4e65090bbdde","15":"0804f52646b7a206db38","16":"97541295a0da95dcc521","17":"dbbc09e3e96407cab406","18":"ca831d60152d95f2b78b","19":"763fcc03bdc64bddcc34","20":"6473350e1cdfb6f712dc","21":"416558902243652a111b","22":"eb06806916e7dba0fb03","23":"4e241720b3cab80cb4fd","24":"a75994c8263aa3b97f80","25":"a62540ae12ddd9cbce78","26":"26f9e07e172487d21657","27":"3a287e709807b456fb83","28":"58bfbe97061dfb88fdf9","29":"aa2b18886c6154764020","30":"88be6ade2388ab0ac39c","31":"e8e78384694f128f19af","32":"314364fe0e4e089b3392","33":"3a8bc19220c26bbfe5d1","34":"4ff58af071cfe8c30e83","35":"f673ad7efb5af12aec11","36":"e8d19db84af69a309ba7","37":"46833e44c98f843a3a7e","38":"7e728f7e4a1b049a3e5b","39":"b52163fb45d5195515a7","42":"b10a866a1628b32dc743","43":"c55df51dce9a8d9ea3a5","44":"d61ccc3630c8c6263f53"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"210db0215931a3e9abee96710e518434acd7c4c0","3":"2fe454eb43ef5d9bb0bb87b43c87706ffeecd892","4":"40b72ecc2a5accc75505486bc26963c7c3b80314","5":"6be459cf3a0383e4f851e82f8f9153af809a37a0","6":"841b02cfb9bcee3ef27fe7f103f51795a4c4c5ae","7":"834b794a2fa97d63fcd1d48709d635bc2bbabd88","8":"b4f28b8dde38944e0d9167a2fa550033034c9e0b","12":"component---src-pages-approach-js","13":"component---src-pages-become-a-carer-js","14":"component---src-pages-blog-js","15":"component---src-pages-care-consultation-js","16":"component---src-pages-companionship-care-js","17":"component---src-pages-condition-cancer-js","18":"component---src-pages-condition-dementia-js","19":"component---src-pages-condition-multiple-sclerosis-js","20":"component---src-pages-condition-parkinsons-js","21":"component---src-pages-condition-stroke-js","22":"component---src-pages-cookies-js","23":"component---src-pages-couples-care-js","24":"component---src-pages-cta-js","25":"component---src-pages-index-js","26":"component---src-pages-live-in-care-south-east-london-js","27":"component---src-pages-liveincare-js","28":"component---src-pages-liveincare-looking-for-care-js","29":"component---src-pages-our-carers-js","30":"component---src-pages-our-team-js","31":"component---src-pages-partner-with-us-js","32":"component---src-pages-pricing-js","33":"component---src-pages-privacy-js","34":"component---src-pages-privacy-version-1-0-js","35":"component---src-pages-request-a-brochure-js","36":"component---src-pages-social-media-studio-js","37":"component---src-pages-terms-and-conditions-js","38":"component---src-templates-blog-post-js","39":"component---src-templates-location-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2bb6621dc11408333d95","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
